import { Button } from '@cian/ui-kit';
import { FC, useRef } from 'react';
import { useSelector } from 'react-redux';
import { authorizedSelector } from '../../selectors/auth';
import { AuthForm } from './AuthForm';
import { dispatchWidgetEvent, EAuthWidgetEventName } from '../../utils/dispatchWidgetEvent';

export const LoginWidget: FC = () => {
  const authorized = useSelector(authorizedSelector);
  const ref = useRef<HTMLDivElement | HTMLButtonElement | null>(null);

  function handleSuccessfulAuth() {
    dispatchWidgetEvent(ref.current, EAuthWidgetEventName.Authorization);
  }

  if (!authorized) {
    return <AuthForm ref={ref as React.MutableRefObject<HTMLDivElement | null>} onAuth={handleSuccessfulAuth} />;
  }

  return (
    <Button ref={ref as React.MutableRefObject<HTMLButtonElement | null>} onClick={handleSuccessfulAuth}>
      Посмотреть предложение
    </Button>
  );
};
